import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TopShareButtons from 'Components/topShareButtons';
import SelectCategories from 'Components/selectCategories';
import SelectIndicators from 'Components/selectIndicators';
import SelectGeos from 'Components/selectGeos';
import TableWrapper from 'Components/tableWrapper';
import Sidebar from 'Components/sidebar';
import utils from 'Utils';
import * as styles from './app.css';
import * as iconStyles from '../../styles/icons.css';

const { mapKV } = utils.obj;

const App = ({ view, viewsEnabled, instruction }) => (
  <div className={styles.app}>
    {1 === viewsEnabled.length && '0' === viewsEnabled[0] && (
      <div className={styles.general}>
        <TopShareButtons />
        <h2 className={styles.generalHeader}>
          About This Tool
        </h2>
        <div
          className={styles.mainInstruction}
          dangerouslySetInnerHTML={instruction.general || ''} // eslint-disable-line react/no-danger
        />
      </div>
    )}
    { '0' === view && (
      <div
        className={styles.instruction}
        dangerouslySetInnerHTML={instruction.category || ''} // eslint-disable-line react/no-danger
      />
    )}
    { '1' === view && (
      <div
        className={styles.instruction}
        dangerouslySetInnerHTML={instruction.indicator || ''} // eslint-disable-line react/no-danger
      />
    )}
    { '2' === view && (
      <div
        className={styles.instruction}
        dangerouslySetInnerHTML={instruction.geographies || ''} // eslint-disable-line react/no-danger
      />
    )}
    { '3' !== view && (
      <div className={styles.resetWrapper}>
        <a
          href="https://kff.org/statedata/custom"
          className={styles.resetAnchorButton}
        >
          <i className={iconStyles.iconNew} />
          <span>Start Over</span>
        </a>
      </div>
    )}
    { '0' === view && (
      <SelectCategories />
    )}
    { '1' === view && (
      <div>
        <div className={styles.wrapper}>
          <div className={styles.main}>
            <SelectIndicators />
          </div>
          <div className={styles.sidebar}>
            <Sidebar />
          </div>
        </div>
      </div>
    )}
    { '2' === view && (
      <div>
        <div className={styles.wrapper}>
          <div className={styles.main}>
            <SelectGeos />
          </div>
          <div className={styles.sidebar}>
            <Sidebar />
          </div>
        </div>
      </div>
    )}
    { '3' === view && (
      <TableWrapper />
    )}
  </div>
);

App.defaultProps = {
  instruction: {},
  view: 0,
};

App.propTypes = {
  view: PropTypes.string,
  viewsEnabled: PropTypes.arrayOf(PropTypes.string).isRequired,
  instruction: PropTypes.shape({
    general: PropTypes.shape({
      __html: PropTypes.string.isRequired,
    }).isRequired,
    category: PropTypes.shape({
      __html: PropTypes.string.isRequired,
    }).isRequired,
    indicator: PropTypes.shape({
      __html: PropTypes.string.isRequired,
    }).isRequired,
    geographies: PropTypes.shape({
      __html: PropTypes.string.isRequired,
    }).isRequired,
    report: PropTypes.shape({
      __html: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

const mapStateToProps = ({
  router: { view },
  data: { verify: { viewsEnabled }, options, print },
}) => ({
  print,
  viewsEnabled,
  view,
  instruction: mapKV(options.instructions, (val) => ({ __html: val })),
});

export default connect(mapStateToProps)(App);

// Testing exports
export { App, mapStateToProps };



// WEBPACK FOOTER //
// ./app/components/app/index.js